import {
	ReactElement,
	useMemo
} from "react";
import { CalendarLayout } from "../../CalendarLayout/CalendarLayout";
import styles from "./HoursColumn.module.less";
import { DayHour, getDayHourRange } from "../getEventsForDay";
import { TimeZone } from "client/DateAndTime/timezones";
import { useCurrentHour } from "client/Hooks";
import classNames from "classnames";

export type HoursColumnProps = {
	timezone: TimeZone;
};

export const HoursColumn = (props: HoursColumnProps): ReactElement => {
	const {
		timezone
	} = props;

	const hourRange = useMemo(
		(): readonly DayHour[] => getDayHourRange(),
		[]
	);

	const currentHour: number = useCurrentHour(timezone);

	return (
		<CalendarLayout.Column
			widthKind="auto"
			trackingId="hours-column"
		>
			{hourRange.map(x => (
				<CalendarLayout.HourBox
					key={x.formattedTime}
				>
					<div
						className={classNames(
							styles.hour,
							{ [styles.hour_current]: x.hour === currentHour }
						)}
					>
						{x.formattedTime}
					</div>
				</CalendarLayout.HourBox>
			))}
		</CalendarLayout.Column>
	);
};
HoursColumn.displayName = "HoursColumn";